<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 my-6 rounded-lg">
      <v-row class="px-4 pb-6 pt-3">
        <v-col cols="12" lg="5" class="pb-0">
          <v-autocomplete
              v-model="selectedProducts"
              multiple
              hide-details
              :items="products"
              label="Selected Products"
              item-text="name"
              outlined
              show-select
              dense
              class="text-body-2 text-capitalize mx-0 my-0 pr-0 pb-0"
              @change="applyFilters"
              tags
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="white" :color="item.color">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                  v-if="index === 2"
                  class="grey--text caption"
              >
                (+{{ selectedProducts.length - 2 }} others)
              </span>
            </template>
            <template v-slot:item="{ active, item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.name }}</span>
                      <v-spacer></v-spacer>
                      <v-icon :color="item.color" dense class="ml-auto">mdi-circle</v-icon>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:prepend-item>
              <v-list-item @click="showAllProducts">
                <v-list-item-action>
                  <v-icon :color="selectedProducts.length > 0 ? 'indigo' : ''">
                    {{ allProductsIcon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    All products
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" lg="5" class="pb-0">
          <v-select
              :items="graphs"
              v-model="selectedGraphs"
              item-value="value"
              item-text="text"
              label="All graphs"
              outlined
              hide-details
              dense chips multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="white" :color="item.color">
                <span>{{ item.descr }}</span>
              </v-chip>
              <span
                  v-if="index === 2"
                  class="grey--text caption"
              >
              (+{{ selectedGraphs.length - 2 }} {{ (selectedGraphs.length - 2) > 1 ? 'others' : 'another' }})
            </span>
            </template>
            <template v-slot:item="{ active, item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.text }}</span>
                      <v-spacer></v-spacer>
                      <v-chip text-color="white" :color="item.color" small>{{ item.descr }}</v-chip>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:prepend-item>
              <v-list-item
                  ripple
                  @click="showAllGraphs"
              >
                <v-list-item-action>
                  <v-icon :color="selectedGraphs.length > 0 ? 'indigo' : ''">
                    {{ allGraphsIcon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    All graphs
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
          <v-spacer></v-spacer>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('orders')" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Monthly Orders Data</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="6">
          <highcharts :options="chartOptionsOrders"></highcharts>
        </v-col>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headersOrders"
              :items="dataOrders"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersOrders" :key="i">
                  <span v-if="i == 0">Total</span>
                  <span v-else>{{ sumField(dataOrders, item.value, i) | formatFloat }}</span>
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('customerType')" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Orders by Hub User Type</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="6">
          <highcharts :options="chartOptionsCustomerType"></highcharts>
        </v-col>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headersOrdersCustomerType"
              :items="dataOrdersCustomerType"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersOrders" :key="i">
                  {{ sumField(dataOrdersCustomerType, item.value, i, true) }}
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('copperCustomerType')" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Orders by Copper Company Type</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="6">
          <highcharts :options="chartOptionsCopperCustomerType"></highcharts>
        </v-col>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headersOrdersCopperCustomerType"
              :items="dataOrdersCopperCustomerType"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersOrders" :key="i">
                  {{ sumFieldCopper(dataOrdersCopperCustomerType, item.value, i, true) }}
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('gallons')" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Monthly Gallons Data</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="6">
          <highcharts :options="chartOptionsGallons"></highcharts>
        </v-col>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headersGallons"
              :items="dataGallons"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersOrders" :key="i">
                  <span v-if="i == 0">Total</span>
                  <span v-else>{{ sumField(dataGallons, item.value, i) | formatFloat }}</span>
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('gallonsByCustomerType')" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Gallons By Hub User Type</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="6">
          <highcharts :options="chartOptionsGallonsByCustomerType"></highcharts>
        </v-col>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headersGallonsCustomerType"
              :items="dataGallonsCustomerType"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersOrders" :key="i">
                  {{ sumField(dataGallonsCustomerType, item.value, i, true) }}
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('gallonsByCopperCustomerType')"
            class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Gallons By Copper Company Type</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="6">
          <highcharts :options="chartOptionsGallonsByCopperCustomerType"></highcharts>
        </v-col>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headersGallonsCopperCustomerType"
              :items="dataGallonsCopperCustomerType"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersOrders" :key="i">
                  {{ sumFieldCopper(dataGallonsCopperCustomerType, item.value, i, true) }}
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('sales')" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Monthly Sales</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="6">
          <highcharts :options="chartOptionsSales"></highcharts>
        </v-col>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headersSales"
              :items="dataSales"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersOrders" :key="i">
                  <span v-if="i == 0">Total</span>
                  <span v-else>{{ sumField(dataSales, item.value, i) | formatPrice }}</span>
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('allActivities')" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" lg="3">
          <h2 class="pl-3 mr-4">All Activities</h2>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
              v-model="selectedYear"
              :items="years"
              label="by Year"
              outlined
              dense
              hide-details
              @input="getAllActivitiesSeries"
          >
          </v-select>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-progress-linear
            indeterminate
            color="indigo"
            v-if="loaded"
        ></v-progress-linear>
        <v-col cols="12" md="8">
          <highcharts :options="chartOptionsAllActivities" :updateArgs="updateArgs"></highcharts>
        </v-col>
        <v-col cols="12" md="4">
          <v-data-table
              :headers="headersAllActivity"
              :items="dataAllActivity"
              :items-per-page="12"
              dense
              hide-default-footer
          >
            <template v-slot:item.total_orders="{ item }">
              <div class="orders px-2">{{ item.total_orders }}</div>
            </template>
            <template v-slot:item.total_gallons="{ item }">
              <div class="gallons px-2">{{ item.total_gallons }}</div>
            </template>
            <template v-slot:item.total_price="{ item }">
              <div class="price px-2">{{ item.total_price }}</div>
            </template>
            <template v-slot:item.recurrent="{ item }">
              <div class="recurrent px-2">{{ item.recurrent }}</div>
            </template>
            <template v-slot:item.new="{ item }">
              <div class="new px-2">{{ item.new }}</div>
            </template>
            <template slot="body.append">
              <tr class="black--text">
                <th class="text-subtitle-2 total-row" v-for="(item, i) in headersAllActivity" :key="i">
                  <span v-if="i == 0">Total</span>
                  <span v-else-if="item.value == 'total_price'">{{
                      sumField(dataAllActivity, item.value, i) | formatPrice
                    }}</span>
                  <span v-else>{{ sumField(dataAllActivity, item.value, i) | formatFloat }}</span>
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import {Chart} from 'highcharts-vue'

export default {
  components: {
    highcharts: Chart
  },
  data() {
    return {
      updateArgs: [true, true, true],
      chartOptionsOrders: {
        chart: {
          height: 500,
          type: 'column',
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
          formatter: function () {
            let tip = `<b>${this.x}</b>`
            tip += `<br/><span>${this.series.name}</span>: ${this.y} orders<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },

        yAxis: {
          min: 0,
          title: {
            text: 'Orders'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5

          }
        },
        series: []
      },
      chartOptionsCopperCustomerType: {
        chart: {
          height: 500,
          type: 'column',
          // events: {
          //   render: function() {
          //    self.sortedChartRender(this.series)
          //   }
          // },
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          labelFormatter: function () {
            return this.name;
          }
        },
        tooltip: {
          formatter: function () {
            let tip = `<b>${this.x} ${this.series.userOptions.stack}</b>`
            tip += `<br/>${this.y} orders of ${this.series.name} customers<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Customers'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5,
            stacking: 'normal',
          }
        },
        series: []
      },
      chartOptionsCustomerType: {
        chart: {
          height: 500,
          type: 'column',
          // events: {
          //   render: function() {
          //    self.sortedChartRender(this.series)
          //   }
          // },
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          labelFormatter: function () {
            return this.name;
          }
        },
        tooltip: {
          formatter: function () {
            let tip = `<b>${this.x} ${this.series.userOptions.stack}</b>`
            tip += `<br/>${this.y} orders of ${this.series.name} customers<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Customers'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5,
            stacking: 'normal',
          }
        },
        series: []
      },
      chartOptionsSales: {
        chart: {
          height: 500,
          type: 'column',
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
          formatter: function () {
            let tip = `<b>${this.x}</b>`
            tip += `<br/>${this.series.name}: $${this.y.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Price'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5
          },
        },
        series: []
      },
      chartOptionsGallons: {
        chart: {
          height: 500,
          type: 'column',
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
          formatter: function () {
            let tip = `<b>${this.x}</b>`
            tip += `<br/><span>${this.series.name}</span>: ${this.y} gallons<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Gallons'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5
          }
        },
        series: [],
      },
      chartOptionsGallonsByCopperCustomerType:{
        chart: {
          height: 500,
          type: 'column',
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          labelFormatter: function () {
            return this.name;
          }
        },
        tooltip: {
          formatter: function () {
            let tip = `<b>${this.x} ${this.series.userOptions.stack}</b>`
            tip += `<br/>${this.y} gallons of ${this.series.name} customers<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Gallons'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5,
            stacking: 'normal',
          }
        },
        series: []
      },
      chartOptionsGallonsByCustomerType: {
        chart: {
          height: 500,
          type: 'column',
          // events: {
          //   render: function() {
          //    self.sortedChartRender(this.series)
          //   }
          // },
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          labelFormatter: function () {
            return this.name;
          }
        },
        tooltip: {
          formatter: function () {
            let tip = `<b>${this.x} ${this.series.userOptions.stack}</b>`
            tip += `<br/>${this.y} gallons of ${this.series.name} customers<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Gallons'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5,
            stacking: 'normal',
          }
        },
        series: []
      },
      chartOptionsAllActivities: {
        chart: {
          height: 500,
          zoomType: 'xy'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value}',
            style: {
              color: '#586ACE'
            }
          },
          title: {
            text: 'Total Orders',
            style: {
              color: '#398BD8'
            }
          }
        }, { // Secondary yAxis
          left: 30,
          title: {
            text: 'Total Gallons',
            style: {
              color: '#43A357'
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: '#43A357'
            }
          },
          opposite: true
        },
          { // Tertiary yAxis
            left: 20,
            gridLineWidth: 0,
            title: {
              text: 'Total Price',
              style: {
                color: '#D87691'
              }
            },
            labels: {
              format: '${value}',
              style: {
                color: '#D87691'
              }
            },
            opposite: true
          }],
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5,
            stacking: 'normal',
          },
          areaspline: {
            fillOpacity: 0.1,
            marker: {
              symbol: 'circle',
              radius: 3
            }
          }
        },
        series: []
      },
      allActivitiesOptions: ['Total Orders', 'New Customers', 'Recurrent Customers', 'Total Gallons', 'Total Price'],
      selectedOptions: ['Total Orders', 'New Customers', 'Recurrent Customers', 'Total Gallons', 'Total Price'],
      selected: [],
      data: [],
      copper_data: [],
      filteredData: [],
      historyChanged: [],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      loaded: false,
      colors: [
        '#EA6565', '#FF9D9D', '#A75E5E', '#EA704A', '#FBC17D', '#FDED9C', '#43A357',
        '#2AC0AC', '#D5E7B1', '#A1E296', '#B9E7F5', '#398BD8', '#96BCF3', '#8166D0',
        '#9C4B9D', '#B386C5', '#ECD3FF', '#F988D9', '#F86499', '#C264F8'
      ],
      products: [],
      selectedProducts: [],
      graphs: [
        {text: 'Monthly Orders', value: 'orders', descr: 'Orders', color: '#6372c3'},
        {text: 'Hub User Type', value: 'customerType', descr: 'Customers', color: '#43A357'},
        {text: 'Copper Customer Type', value: 'copperCustomerType', descr: 'Copper Customer Type', color: '#a37943'},
        {text: 'Monthly Gallons', value: 'gallons', descr: 'Gallons', color: '#9d994b'},
        {
          text: 'Gallons By Hub User Type',
          value: 'gallonsByCustomerType',
          descr: 'Gallons By Hub User Type',
          color: '#9C4B9D'
        },
        {
          text: 'Gallons By Copper Customer Type',
          value: 'gallonsByCopperCustomerType',
          descr: 'Gallons By Copper Customer Type',
          color: '#9d4b5e'
        },
        {text: 'Monthly Sales', value: 'sales', descr: 'Sales', color: '#d87691'},
        {text: 'All Activities', value: 'allActivities', descr: 'Activities', color: '#f79e20'},
      ],
      selectedGraphs: ['orders', 'customerType', 'gallons', 'gallonsByCustomerType', 'gallonsByCopperCustomerType', 'sales', 'allActivities', 'copperCustomerType'],
      groupByYear: [],
      compaignsByCompaign: [],
      selectedYear: new Date().getFullYear(),
      years: [],
      dataAllActivity: [],
      headersAllActivity: [
        {text: 'Month', value: 'month', class: 'black--text', sortable: false},
        {text: 'Orders', value: 'total_orders', class: 'black--text'},
        {text: 'Gallons', value: 'total_gallons', class: 'black--text'},
        {text: 'Price,$', value: 'total_price', class: 'black--text'},
        {text: 'Recurrent', value: 'recurrent', class: 'black--text'},
        {text: 'New', value: 'new', class: 'black--text'},
      ],
      headersOrders: [
        {text: 'Orders', value: 'month', class: 'black--text', sortable: false},
      ],
      headersOrdersCustomerType: [
        {text: 'Orders New/Recurrent', value: 'month', class: 'black--text', sortable: false},
      ],
      headersOrdersCopperCustomerType:[
          {text: 'Orders NA/New/Recurrent', value: 'month', class: 'black--text', sortable: false},
      ],
      headersGallons: [
        {text: 'Gallons', value: 'month', class: 'black--text', sortable: false},
      ],
      headersGallonsCustomerType: [
        {text: 'Gallons New/Recurrent', value: 'month', class: 'black--text', sortable: false},
      ],
      headersGallonsCopperCustomerType:[
        {text: 'Gallons NA/New/Recurrent', value: 'month', class: 'black--text', sortable: false},
      ],
      headersSales: [
        {text: 'Sales', value: 'month', class: 'black--text', sortable: false},
      ],
      dataOrders: [],
      dataOrdersCustomerType: [],
      dataOrdersCopperCustomerType: [],
      dataGallons: [],
      dataGallonsCustomerType: [],
      dataGallonsCopperCustomerType: [],
      dataSales: [],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }
  },
  created() {
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }
    this.getProducts()
    //this.applyFilters()
  },
  watch: {
    selectedProducts() {
      this.getDataForTables()
    }
  },
  computed: {
    allGraphsIcon() {
      if (this.selectedGraphs.length == this.graphs.length) return 'mdi-close-box'
      if (this.selectedGraphs.length < this.graphs.length) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allProductsIcon() {
      if (this.selectedProducts.length == this.products.length) return 'mdi-close-box'
      if (this.selectedProducts.length < this.products.length && this.selectedProducts.length > 0) return 'mdi-minus-box'
      //return 'mdi-checkbox-marked'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    sortedChartRender: function (series) {
      if (series.length === 0) return
      var longestSeries = series[0],
          sortedPoints = [],
          selectedPoints = [];

      // find a series with the highest amount of points
      series.forEach(function (s) {
        if (s.points.length > longestSeries.points.length) {
          longestSeries = s;
        }
      });

      longestSeries.points.forEach(function (point) {
        series.forEach(function (s) {
          selectedPoints.push(s.points[point.index]);
        });

        sortedPoints = selectedPoints.slice().sort(function (a, b) {
          b = b.y ? b.y : 0
          a = a.y ? a.y : 0
          return b - a
        });


        selectedPoints.forEach(function (selectedPoint) {

          if (
              selectedPoints.indexOf(selectedPoint) !==
              sortedPoints.indexOf(selectedPoint) &&
              selectedPoint.graphic
          ) {
            // change column position
            selectedPoint.graphic.attr({
              x: selectedPoints[sortedPoints.indexOf(selectedPoint)].shapeArgs.x
            });
          }
        });
        sortedPoints.length = 0;
        selectedPoints.length = 0;
      });

    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    showAllProducts() {

      if (this.selectedProducts.length == this.products.length) {
        this.selectedProducts = []
      } else {
        this.selectedProducts = this.products.slice().map(e => e.name)
      }

      this.applyFilters()
    },
    getDataForTables() {
      this.headersOrders = [{text: 'Orders', value: 'month', class: 'black--text', sortable: false}]
      this.headersOrdersCustomerType = [{
        text: 'Orders New/Recurrent',
        value: 'month',
        class: 'black--text',
        sortable: false
      }]
      this.headersOrdersCopperCustomerType = [{
        text: 'Orders NA/New/Recurrent',
        value: 'month',
        class: 'black--text',
        sortable: false
      }]
      this.headersGallons = [{text: 'Gallons', value: 'month', class: 'black--text', sortable: false}]
      this.headersGallonsCustomerType = [{
        text: 'Gallons New/Recurrent',
        value: 'month',
        class: 'black--text',
        sortable: false
      }]
      this.headersGallonsCopperCustomerType = [{
        text: 'Gallons NA/New/Recurrent',
        value: 'month',
        class: 'black--text',
        sortable: false
      }]
      this.headersSales = [{text: 'Sales', value: 'month', class: 'black--text', sortable: false}]

      this.years.map(e => {
        this.headersOrders.push({text: e, value: `${e}`, class: 'black--text'})
        this.headersGallons.push({text: e, value: `${e}`, class: 'black--text'})
        this.headersSales.push({text: e, value: `${e}`, class: 'black--text'})
        this.headersOrdersCustomerType.push({text: e, value: `${e}`, class: 'black--text'})
        this.headersOrdersCopperCustomerType.push({text: e, value: `${e}`, class: 'black--text'})
        this.headersGallonsCustomerType.push({text: e, value: `${e}`, class: 'black--text'})
        this.headersGallonsCopperCustomerType.push({text: e, value: `${e}`, class: 'black--text'})
      })
      let tableDataByMonth = this._.chain(this.data)
          .groupBy("month")
          .map((value, key) => ({label: key, value: value}))
          .value()
      let tableDataByYear = tableDataByMonth.map(e => this._.chain(e.value)
          .groupBy("year")
          .map((value, key) => ({label: key, value: value}))
          .value())

      let tableDataByYearFilterd =
          //(this.selectedProducts.length === 0) ? tableDataByYear :
          tableDataByYear.map(e => {
            return e.map(el => {
              return {
                label: el.label,
                value: el.value.map(i => {
                  return {
                    customer_type: i.customer_type,
                    month: i.month,
                    year: i.year,
                    total_gallons: i.total_gallons,
                    total_price: i.total_price,
                    products: i.products.filter(el => this.selectedProducts.includes(el[0].name))
                  }
                })
              }
            })
          })

      let copperTableDataByMonth = this._.chain(this.copper_data)
          .groupBy("month")
          .map((value, key) => ({label: key, value: value}))
          .value()
      let copperTableDataByYear = copperTableDataByMonth.map(e => this._.chain(e.value)
          .groupBy("year")
          .map((value, key) => ({label: key, value: value}))
          .value())

      let copperTableDataByYearFilterd =
          copperTableDataByYear.map(e => {
            return e.map(el => {
              return {
                label: el.label,
                value: el.value.map(i => {
                  return {
                    copper_customer_type: i.copper_customer_type,
                    month: i.month,
                    year: i.year,
                    total_gallons: i.total_gallons,
                    total_price: i.total_price,
                    products: i.products.filter(el => this.selectedProducts.includes(el[0].name))
                  }
                })
              }
            })
          })

      this.dataOrders = tableDataByYearFilterd.map((e, i) => {
        let data = {
          month: this.months[i],
        }
        e.map(el => {
          data[el.label] = el.value.reduce((acc, e) => acc + e.products.length, 0)
        })

        return data
      })

      this.dataGallons = tableDataByYearFilterd.map((e, i) => {
        let data = {
          month: this.months[i],
        }
        e.map(el => {
          data[el.label] = el.value.reduce((acc, e) => acc + e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0), 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        })
        return data
      })

      this.dataSales = tableDataByYearFilterd.map((e, i) => {
        let data = {
          month: this.months[i],
        }
        e.map(el => {
          data[el.label] = el.value.reduce((acc, e) => acc + e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.sale_price, 0), 0), 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        })
        return data
      })

      this.dataOrdersCustomerType = tableDataByYearFilterd.map((e, i) => {
        let data = {
          month: this.months[i],
        }
        e.map(el => {
          data[el.label] = el.value.length > 1
              ? el.value.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e.products.length].join(''), [])
              : el.value[0].products.length + '/0'
        })
        return data
      })

      this.dataOrdersCopperCustomerType = copperTableDataByYearFilterd.map((e, i) => {
        let data = {
          month: this.months[i],
        }
        e.map(el => {
          data[el.label] = el.value.length > 1
              ? el.value.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e.products.length].join(''), [])
              : el.value[0].products.length + '/0'
        })
        return data
      })

      this.dataGallonsCopperCustomerType = copperTableDataByYearFilterd.map((e, i) => {
        let data = {
          month: this.months[i],
        }
        e.map(el => {
          data[el.label] = el.value.length > 1
              ? el.value.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0)].join(''), [])
              : el.value[0].products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0) + '/0'
        })
        return data
      })

      this.dataGallonsCustomerType = tableDataByYearFilterd.map((e, i) => {
        let data = {
          month: this.months[i],
        }
        e.map(el => {
          data[el.label] = el.value.length > 1
              ? el.value.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0)].join(''), [])
              : el.value[0].products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0) + '/0'
        })
        return data
      })
    },
    sumField(table, key, i, isByCustomerType) {
      if (isByCustomerType) {
        let result = []
        result[0] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[0] || 0) : 0), 0)
        result[1] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[1] || 0) : 0), 0)
        return i == 0 ? 'Total' : result.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e].join(''), [])
      }
      return i == 0 ? 'Total' : table.reduce((acc, b) => {
        let a = (typeof b[key] == 'string' ? parseFloat(b[key].replace(/,/g, '')) : b[key]) || 0
        return acc + a
      }, 0)
    },
    sumFieldCopper(table, key, i, isByCustomerType) {
      if (isByCustomerType) {
        let result = []
        result[0] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[0] || 0) : 0), 0)
        result[1] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[1] || 0) : 0), 0)
        result[2] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[2] || 0) : 0), 0)
        return i == 0 ? 'Total' : result.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e].join(''), [])
      }
      return i == 0 ? 'Total' : table.reduce((acc, b) => {
        let a = (typeof b[key] == 'string' ? parseFloat(b[key].replace(/,/g, '')) : b[key]) || 0
        return acc + a
      }, 0)
    },
    getColor(i) {
      return this.colors[i]
    },
    getProducts() {
      this.loaded = true
      axios
          .get('/reports/monthly-sale')
          .then(response => {
            this.data = response.data.data
            this.copper_data = response.data.copper_data
            this.products = [...new Set(this.data.map(e => e.products
                .map(i => i.map(o => o.name))
            ).flat(Infinity))]
                .slice().sort()
                .map((el, i) => {
                  return {name: el, color: this.colors[i]}
                })

            this.groupByYear = this._.chain(this.data)
                .groupBy("year")
                .map((value, key) => ({label: key, value: value}))
                .value()

            this.groupByYearCopper = this._.chain(this.copper_data)
                .groupBy("year")
                .map((value, key) => ({label: key, value: value}))
                .value()


            this.years = this.groupByYear.map(e => +e.label).reverse()
            this.selectedYear = this.years[0]

            this.selectedProducts = this.products.slice().map(e => e.name)
            this.applyFilters()
          })
    },
    applyFilters() {
      this.loaded = true

      this.copperFilteredData = this.groupByYearCopper.map(e => {
        return {
          label: e.label,
          value: e.value.map(i => {
            return {
              copper_customer_type: i.copper_customer_type,
              month: i.month,
              year: i.year,
              total_gallons: i.total_gallons,
              total_price: i.total_price,
              products: i.products.filter(el => this.selectedProducts.includes(el[0].name))
            }
          })
        }
      })

      this.filteredData = this.groupByYear.map(e => {
        return {
          label: e.label,
          value: e.value.map(i => {
            return {
              copper_customer_type: i.copper_customer_type,
              customer_type: i.customer_type,
              month: i.month,
              year: i.year,
              total_gallons: i.total_gallons,
              total_price: i.total_price,
              products: i.products.filter(el => this.selectedProducts.includes(el[0].name))
            }
          })
        }
      })

      this.chartOptionsOrders.xAxis.categories = this.months
      this.chartOptionsSales.xAxis.categories = this.months
      this.chartOptionsGallons.xAxis.categories = this.months
      this.chartOptionsCustomerType.xAxis.categories = this.months
      this.chartOptionsCopperCustomerType.xAxis.categories = this.months
      this.chartOptionsAllActivities.xAxis.categories = this.months
      this.chartOptionsGallonsByCustomerType.xAxis.categories = this.months
      this.chartOptionsGallonsByCopperCustomerType.xAxis.categories = this.months
      this.getDataForTables()

      this.chartOptionsSales.series = this.filteredData.map((e, i) => {
        let groupByMonth = this._.chain(e.value)
            .groupBy("month")
            .map((value, key) => ({name: key, value: value}))
            .value()

        let data = []
        groupByMonth.map(el => {
          data[+el.name - 1] = el.value.reduce((acc, e) => acc + e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.sale_price, 0), 0), 0)
        })
        for (let i = 0; i < 12; i++) {
          data[i] = (!data[i]) ? 0 : data[i]
        }
        return {
          name: e.label,
          data: data,
          color: this.colors[i]
        }
      })

      this.chartOptionsOrders.series = this.filteredData.map((e, i) => {
        let groupByMonth = this._.chain(e.value)
            .groupBy("month")
            .map((value, key) => ({name: key, value: value}))
            .value()

        let data = []
        groupByMonth.map(el => {
          data[+el.name - 1] = el.value.reduce((acc, e) => acc + e.products.length, 0)
        })
        for (let i = 0; i < 12; i++) {
          data[i] = (!data[i]) ? 0 : data[i]
        }
        return {
          name: e.label,
          data: data,
          color: this.colors[i]
        }
      })

      this.chartOptionsGallons.series = this.filteredData.map((e, i) => {
        let groupByMonth = this._.chain(e.value)
            .groupBy("month")
            .map((value, key) => ({name: key, value: value}))
            .value()

        let data = []
        groupByMonth.map(el => {
          data[+el.name - 1] = el.value.reduce((acc, e) => acc + e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0), 0)
        })
        for (let i = 0; i < 12; i++) {
          data[i] = (!data[i]) ? 0 : data[i]
        }
        return {
          name: e.label,
          data: data,
          color: this.colors[i]
        }
      })

      this.chartOptionsGallonsByCustomerType.series = this.filteredData.map((e, i) => {
        let groupByMonth = this._.chain(e.value)
            .groupBy("month")
            .map((value, key) => ({name: key, value: value}))
            .value()

        let dataNew = []
        let dataRecurrent = []
        groupByMonth.map(el => {
          dataNew[+el.name - 1] = el.value.reduce((acc, el) => ((el.customer_type == 'New') ? acc + el.products.reduce((acc, i) => i.reduce((acc, el) => acc + el.gallons, 0) + acc, 0) : acc), 0)
          dataRecurrent[+el.name - 1] = el.value.reduce((acc, el) => ((el.customer_type == 'Recurrent') ? acc + el.products.reduce((acc, i) => i.reduce((acc, el) => acc + el.gallons, 0) + acc, 0) : acc), 0)
        })
        for (let i = 0; i < 12; i++) {
          dataNew[i] = (!dataNew[i]) ? 0 : dataNew[i]
          dataRecurrent[i] = (!dataRecurrent[i]) ? 0 : dataRecurrent[i]
        }
        let serieNew = {
          name: 'New',
          data: dataNew,
          color: '#FFAC19',
          stack: e.label,
          showInLegend: i == 0
        }
        let serieRecurrent = {
          name: 'Recurrent',
          data: dataRecurrent,
          color: '#586ACE',
          stack: e.label,
          showInLegend: i == 0
        }
        return [serieNew, serieRecurrent]
      }).flat()

      this.chartOptionsGallonsByCopperCustomerType.series = this.copperFilteredData.map((e, i) => {
        let groupByMonth = this._.chain(e.value)
            .groupBy("month")
            .map((value, key) => ({name: key, value: value}))
            .value()

        let dataNew = []
        let dataRecurrent = []
        let dataNa = []
        groupByMonth.map(el => {
          dataNew[+el.name - 1] = el.value.reduce((acc, el) => ((el.copper_customer_type == 'New') ? acc + el.products.reduce((acc, i) => i.reduce((acc, el) => acc + el.gallons, 0) + acc, 0) : acc), 0)
          dataRecurrent[+el.name - 1] = el.value.reduce((acc, el) => ((el.copper_customer_type == 'Recurrent') ? acc + el.products.reduce((acc, i) => i.reduce((acc, el) => acc + el.gallons, 0) + acc, 0) : acc), 0)
          dataNa[+el.name - 1] = el.value.reduce((acc, el) => ((el.copper_customer_type == 'N/A') ? acc + el.products.reduce((acc, i) => i.reduce((acc, el) => acc + el.gallons, 0) + acc, 0) : acc), 0)
        })
        for (let i = 0; i < 12; i++) {
          dataNew[i] = (!dataNew[i]) ? 0 : dataNew[i]
          dataRecurrent[i] = (!dataRecurrent[i]) ? 0 : dataRecurrent[i]
          dataNa[i] = (!dataNa[i]) ? 0 : dataNa[i]
        }
        let serieNew = {
          name: 'New',
          data: dataNew,
          color: '#FFAC19',
          stack: e.label,
          showInLegend: i == 0
        }
        let serieRecurrent = {
          name: 'Recurrent',
          data: dataRecurrent,
          color: '#586ACE',
          stack: e.label,
          showInLegend: i == 0
        }
        let seriesNa = {
          name: 'N/A',
          data: dataNa,
          color: '#58ceab',
          stack: e.label,
          showInLegend: i == 0
        }
        return [serieNew, serieRecurrent, seriesNa]
      }).flat()


      this.chartOptionsCustomerType.series = this.filteredData.map((e, i) => {
        let groupByMonth = this._.chain(e.value)
            .groupBy("month")
            .map((value, key) => ({name: key, value: value}))
            .value()

        let dataNew = []
        let dataRecurrent = []
        groupByMonth.map(el => {
          dataNew[+el.name - 1] = el.value.reduce((acc, el) => (el.customer_type == 'New') ? acc + el.products.length : acc, 0)
          dataRecurrent[+el.name - 1] = el.value.reduce((acc, el) => ((el.customer_type == 'Recurrent') ? acc + el.products.length : acc), 0)
        })
        for (let i = 0; i < 12; i++) {
          dataNew[i] = (!dataNew[i]) ? 0 : dataNew[i]
          dataRecurrent[i] = (!dataRecurrent[i]) ? 0 : dataRecurrent[i]
        }
        let serieNew = {
          name: 'New',
          data: dataNew,
          color: '#FFAC19',
          stack: e.label,
          showInLegend: i == 0
        }
        let serieRecurrent = {
          name: 'Recurrent',
          data: dataRecurrent,
          color: '#586ACE',
          stack: e.label,
          showInLegend: i == 0
        }
        return [serieNew, serieRecurrent]
      }).flat()

      this.chartOptionsCopperCustomerType.series = this.copperFilteredData.map((e, i) => {
        let groupByMonth = this._.chain(e.value)
            .groupBy("month")
            .map((value, key) => ({name: key, value: value}))
            .value()

        let dataNew = []
        let dataRecurrent = []
        let dataNa = []
        groupByMonth.map(el => {
          dataNew[+el.name - 1] = el.value.reduce((acc, el) => (el.copper_customer_type == 'New') ? acc + el.products.length : acc, 0)
          dataRecurrent[+el.name - 1] = el.value.reduce((acc, el) => ((el.copper_customer_type == 'Recurrent') ? acc + el.products.length : acc), 0)
          dataNa[+el.name - 1] = el.value.reduce((acc, el) => ((el.copper_customer_type == 'N/A') ? acc + el.products.length : acc), 0)
        })
        for (let i = 0; i < 12; i++) {
          dataNew[i] = (!dataNew[i]) ? 0 : dataNew[i]
          dataRecurrent[i] = (!dataRecurrent[i]) ? 0 : dataRecurrent[i]
          dataNa[i] = (!dataNa[i]) ? 0 : dataNa[i]
        }
        let serieNew = {
          name: 'New',
          data: dataNew,
          color: '#FFAC19',
          stack: e.label,
          showInLegend: i == 0
        }
        let serieRecurrent = {
          name: 'Recurrent',
          data: dataRecurrent,
          color: '#586ACE',
          stack: e.label,
          showInLegend: i == 0
        }
        let seriesNa = {
          name: 'N/A',
          data: dataNa,
          color: '#58ceab',
          stack: e.label,
          showInLegend: i == 0
        }
        return [serieNew, serieRecurrent, seriesNa]
      }).flat()

      this.getAllActivitiesSeries()
      this.loaded = false
      //})
    },
    getAllActivitiesSeries() {
      let valueByYear = this.filteredData.find(e => +e.label == this.selectedYear) || this.filteredData.find(e => +e.label == this.selectedYear - 1)
      let groupByMonth = this._.chain(valueByYear.value)
          .groupBy("month")
          .map((value, key) => ({name: key, value: value}))
          .value()

      let data_ordersNew = []
      let data_ordersRecurrent = []
      let data_orders = []
      let data_gallons = []
      let data_price = []

      groupByMonth.map(el => {
        data_ordersNew[+el.name - 1] = el.value.find(e => e.customer_type == 'New')?.products.length || 0
        data_ordersRecurrent[+el.name - 1] = el.value.find(e => e.customer_type == 'Recurrent')?.products.length || 0
        data_orders[+el.name - 1] = el.value.reduce((acc, e) => acc + e.products.length, 0)
        data_gallons[+el.name - 1] = el.value.reduce((acc, e) => e.products.length > 0 ? (acc + e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0)) : 0, 0)
        data_price[+el.name - 1] = Math.round(el.value.reduce((acc, e) => e.products.length > 0 ? (acc + e.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.sale_price, 0), 0)) : 0, 0) * 100) / 100
      })
      for (let i = 0; i < 12; i++) {
        data_ordersNew[i] = (!data_ordersNew[i]) ? 0 : data_ordersNew[i]
        data_ordersRecurrent[i] = (!data_ordersRecurrent[i]) ? 0 : data_ordersRecurrent[i]
        data_orders[i] = (!data_orders[i]) ? 0 : data_orders[i]
        data_gallons[i] = (!data_gallons[i]) ? 0 : data_gallons[i]
        data_price[i] = (!data_price[i]) ? 0 : data_price[i]
      }
      let serieOrdersNew = {
        name: 'New Customers',
        data: data_ordersNew,
        color: '#F79E20',
        type: 'column',
        stack: 1,
      }
      let serieOrdersRecurrent = {
        name: 'Recurrent Customers',
        data: data_ordersRecurrent,
        color: '#586ACE',
        type: 'column',
        stack: 1,
      }
      let serieGallons = {
        name: 'Total Gallons',
        data: data_gallons,
        color: '#43A357',
        type: 'line',
        dashStyle: 'shortdot',
        yAxis: 1,
      }
      let seriePrice = {
        name: 'Total Price',
        data: data_price,
        color: '#D87691',
        type: 'areaspline',
        yAxis: 2,
      }
      let serieOrders = {
        name: 'Total Orders',
        data: data_orders,
        color: '#398BD8',
        type: 'line',
      }
      this.chartOptionsAllActivities.series = [serieOrdersNew, serieOrdersRecurrent, serieOrders, serieGallons, seriePrice]
      this.dataAllActivity = groupByMonth.map(e => {
        return {
          month: this.months[e.value[0].month - 1],
          total_orders: e.value.reduce((acc, el) => acc + el.products.length, 0),
          total_price: e.value.reduce((acc, el) => acc + el.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.sale_price, 0), 0), 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          total_gallons: e.value.reduce((acc, el) => acc + el.products.reduce((acc, i) => acc + i.reduce((acc, el) => acc + el.gallons, 0), 0), 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          new: e.value.find(e => e.customer_type == 'New')?.products.length || 0,
          recurrent: e.value.find(e => e.customer_type == 'Recurrent')?.products.length || 0
        }
      })
    },
    showAllGraphs() {
      this.$nextTick(() => {
        if (this.selectedGraphs.length == this.graphs.length) {
          this.selectedGraphs = []
        } else {
          this.selectedGraphs = this.graphs.slice().map(e => e.value)
        }
      })
    }
  }
}
</script>

<style scoped>
.total-row {
  border-top: 2px solid gray;
}

.v-chip.v-size--default {
  border-radius: 16px;
  font-size: 13px;
  height: 26px;
}

.v-select.v-input--dense .v-chip {
  margin: 4px 4px 0px 4px;
}

.orders {
  line-height: 2.5;
  background-color: rgba(57, 139, 216, 0.3);
}

.gallons {
  line-height: 2.5;
  background-color: rgba(67, 163, 87, 0.3);
}

.price {
  line-height: 2.5;
  background-color: rgba(216, 118, 145, 0.3);
}

.recurrent {
  line-height: 2.5;
  background-color: rgba(88, 106, 206, 0.3);
}

.new {
  line-height: 2.5;
  background-color: rgba(255, 172, 25, 0.3);
}

.v-data-table >>> div > table .text-start {
  padding: 0;
}

.v-data-table >>> div > table tr {
  border: 1px solid black !important;
}
</style>